/* eslint-disable indent */
/* eslint-disable no-multi-spaces */
import stampit from 'stampit'
import EventEmitter from 'events'

const hasWindow = typeof window === 'object' && window !== null && window.self === window && window.navigator !== null
const bIsiOS = hasWindow && /iPad|iPhone|iPod/.test(window.navigator.userAgent) && !window.MSStream
const hasSpeechSynthesis = hasWindow && window.speechSynthesis !== null

// Stamp with defaults
const Voice = stampit({
  props: {
    // 'en', en-US', 'ru-RU', etc.
    locale: 'en-US',
    index: 0, // an index that helps specify which voice you want when multiple will do
    name: '',
    bIsMale: false
  },
  init ({locale, bIsMale, index, name}) {
    if (name) {
      var props = Voice.voiceProperties[name]
      if (props) {
        if (!bIsMale) {
          bIsMale = props.male || false
        }
      }
    }
    this.locale = locale || this.locale
    this.bIsMale = bIsMale || this.bIsMale
    this.index = index || 0
    this.name = name
  },
  methods: {
  },
  statics: { // creates a new derived stamp
    eventEmitter: new EventEmitter(),
    voiceCounter: 0,
    iOSVoiceNames: [
      'Maged',
      'Zuzana',
      'Sara',
      'Anna',
      'Melina',
      'Karen',
      'Samantha',
      'Daniel',
      'Rishi',
      'Moira',
      'Tessa',
      'Mónica',
      'Paulina',
      'Satu',
      'Amélie',
      'Thomas',
      'Carmit',
      'Lekha',
      'Mariska',
      'Damayanti',
      'Alice',
      'Kyoko',
      'Yuna',
      'Ellen',
      'Xander',
      'Nora',
      'Zosia',
      'Luciana',
      'Joana',
      'Ioana',
      'Milena',
      'Laura',
      'Alva',
      'Kanya',
      'Yelda',
      'Tian-Tian',
      'Sin-Ji',
      'Mei-Jia'
    ],

    minimumPriority: 10,
    voiceProperties: {
      'Microsoft David Desktop - English (United States)': { male: true, priority: 13 },
      'Microsoft Hazel Desktop - English (Great Britain)': { male: false, priority: 14 },
      'Microsoft Zira Desktop - English (United States)': { male: false, priority: 14 },
      'Google US English': { male: true, priority: 44 },
      'Google UK English Female': { male: false, priority: 44 },
      'Google UK English Male': { male: true, priority: 43 },
      'Lee': { male: true, priority: 33 },
      'Fred': { male: true, priority: 8 },
      'Alex': { male: true, priority: 34 },
      'Daniel': { male: true, priority: 33 },
      'Daniel (Enhanced)': { male: true, priority: 43 },
      'Oliver': { male: true, priority: 33 },
      'Oliver (Enhanced)': { male: true, priority: 43 },
      'Samantha': { male: false, priority: 38 },
      'Serena': { male: false, priority: 35 },
      'Victoria': { male: false, priority: 9 },
      'Vicki': { male: false, priority: 33 },
      'Veena': { male: false, priority: 32 },
      'Tessa': { male: false, priority: 37 },
      'Fiona': { male: false, priority: 37 },
      'Moira': { male: false, priority: 37 },
      'Karen': { male: false, priority: 37 },
      'Thomas': { male: true, priority: 37 },
      'Boing': { male: true, priority: 1 },
      'Bad News': { male: true, priority: 1 },
      'Agnes': { male: false, priority: 5 },
      'Bahh': { male: true, priority: 1 },
      'Bells': { male: true, priority: 1 },
      'Cellos': { male: true, priority: 1 },
      'Albert': { male: true, priority: 1 },
      'Bubbles': { male: true, priority: 1 },
      'Deranged': { male: true, priority: 1 },
      'Good News': { male: true, priority: 1 },
      'Hysterical': { male: true, priority: 1 },
      'Junior': { male: true, priority: 1 },
      'Kathy': { male: true, priority: 5 },
      'Pipe Organ': { male: true, priority: 1 },
      'Princess': { male: false, priority: 1 },
      'Trinoids': { male: true, priority: 1 },
      'Whisper': { male: true, priority: 1 },
      'Zarvox': { male: true, priority: 1 }
    },
    lowerCaseMaleNames: [
      'guy',
      'david',
      'mark'
    ],
    languageProperties: {
      'en': 'English',
      'zh': 'Chinese',
      'ru': 'Russian',
      'de': 'German',
      'it': 'Italian',
      'pt': 'Portuguese',
      'vi': 'Vietnamese',
      'tr': 'Turkish',
      'th': 'Thai',
      'es': 'Spanish',
      'fr': 'French',
      'sk': 'Slovak',
      'ro': 'Romanian',
      'pl': 'Polish',
      'nl': 'Dutch',
      'ko': 'Korean',
      'ja': 'Japanese',
      'he': 'Hebrew',
      'el': 'Greek',
      'fi': 'Finish',
      'da': 'Danish',
      'cs': 'Czech',
      'ar': 'Arabic',
      'sv': 'Swedish',
      'hi': 'Hindi',
      'hu': 'Hungarian',
      'nb': 'Norwegian',
      'no': 'Norwegian (iOS)',
      'id': 'Indonesian'
    },
    languagePropertiesInverted: {
      'English': 'en',
      'Chinese': 'zh',
      'Spanish': 'es',
      'French': 'fr',
      'Russian': 'ru',
      'German': 'de',
      'Italian': 'it',
      'Portuguese': 'pt',
      'Japanese': 'ja',
      'Korean': 'ko',
      'Hindi': 'hi',
      'Vietnamese': 'vi',
      'Turkish': 'tr',
      'Thai': 'th',
      'Slovak': 'sk',
      'Romanian': 'ro',
      'Polish': 'pl',
      'Dutch': 'nl',
      'Hebrew': 'he',
      'Greek': 'el',
      'Finish': 'fi',
      'Norwegian': 'nb',
      'Norwegian (iOS)': 'no',
      'Danish': 'da',
      'Czech': 'cs',
      'Arabic': 'ar',
      'Swedish': 'sv',
      'Hungarian': 'hu',
      'Indonesian': 'id'
    },
    chromeRecognition: [
      ['Afrikaans',       ['af-ZA']],
      // eslint-disable-next-line comma-spacing
      ['Bahasa Indonesia',['id-ID']],
      ['Bahasa Melayu',   ['ms-MY']],
      ['Català',          ['ca-ES']],
      ['Čeština',         ['cs-CZ']],
      ['Deutsch',         ['de-DE']],
      ['English',         ['en-AU', 'Australia'],
                          ['en-CA', 'Canada'],
                          ['en-IN', 'India'],
                          ['en-NZ', 'New Zealand'],
                          ['en-ZA', 'South Africa'],
                          ['en-GB', 'United Kingdom'],
                          ['en-US', 'United States']],
      ['Español',         ['es-AR', 'Argentina'],
                          ['es-BO', 'Bolivia'],
                          ['es-CL', 'Chile'],
                          ['es-CO', 'Colombia'],
                          ['es-CR', 'Costa Rica'],
                          ['es-EC', 'Ecuador'],
                          ['es-SV', 'El Salvador'],
                          ['es-ES', 'España'],
                          ['es-US', 'Estados Unidos'],
                          ['es-GT', 'Guatemala'],
                          ['es-HN', 'Honduras'],
                          ['es-MX', 'México'],
                          ['es-NI', 'Nicaragua'],
                          ['es-PA', 'Panamá'],
                          ['es-PY', 'Paraguay'],
                          ['es-PE', 'Perú'],
                          ['es-PR', 'Puerto Rico'],
                          ['es-DO', 'República Dominicana'],
                          ['es-UY', 'Uruguay'],
                          ['es-VE', 'Venezuela']],
      ['Euskara',         ['eu-ES']],
      ['Français',        ['fr-FR']],
      ['Galego',          ['gl-ES']],
      ['Hrvatski',        ['hr_HR']],
      ['IsiZulu',         ['zu-ZA']],
      ['Íslenska',        ['is-IS']],
      ['Italiano',        ['it-IT', 'Italia'],
                          ['it-CH', 'Svizzera']],
      ['Magyar',          ['hu-HU']],
      ['Nederlands',      ['nl-NL']],
      ['Norsk bokmål',    ['nb-NO']],
      ['Polski',          ['pl-PL']],
      ['Português',       ['pt-BR', 'Brasil'],
                          ['pt-PT', 'Portugal']],
      ['Română',          ['ro-RO']],
      ['Slovenčina',      ['sk-SK']],
      ['Suomi',           ['fi-FI']],
      ['Svenska',         ['sv-SE']],
      ['Türkçe',          ['tr-TR']],
      ['български',       ['bg-BG']],
      ['Pусский',         ['ru-RU']],
      ['Српски',          ['sr-RS']],
      ['한국어',            ['ko-KR']],
      // google appears to accept zh-CN for chinese, which makes our lives easier.
      ['中文',             ['cmn-Hans-CN', '普通话 (中国大陆)'],
                          ['cmn-Hans-HK', '普通话 (香港)'],
                          ['cmn-Hant-TW', '中文 (台灣)'],
                          ['yue-Hant-HK', '粵語 (香港)']],
      ['日本語',           ['ja-JP']],
      ['Lingua latīna',   ['la']]
    ],
    isMale (voiceName)  {
      if (voiceName in Voice.voiceProperties) {
        return Voice.voiceProperties[voiceName].male
      }
      voiceName = voiceName.toLowerCase()
      if (voiceName.includes('female')) {
        return false
      }
      if (voiceName.includes('male')) {
        return true
      }
      for (var i = 0; i < Voice.lowerCaseMaleNames.length; ++i) {
        if (voiceName.includes(Voice.lowerCaseMaleNames[i])) {
          return true
        }
      }
      return false
    },
    getRecognitionLanguages () {
      var languages = []
      for (var i = 0; i < Voice.chromeRecognition.length; i++) {
        languages.push(Voice.chromeRecognition[i][0])
      }
      return languages
    },
    getLangauges () {
      var codes = []
      var languages = []
      function onlyUnique (value, index, self) {
        return self.indexOf(value) === index
      }
      if (hasSpeechSynthesis) {
        this.getVoices().forEach(function (v) {
          codes.push(v.lang.substring(0, 2))
        })
      }
      let unique = codes.filter(onlyUnique)
      unique.forEach(function (l) {
        if (l in Voice.languageProperties) {
          languages.push(Voice.languageProperties[l])
        } else {
          languages.push(l)
        }
      })
      return languages
    },
    getVoicesForLangauge (language) {
      var code = Voice.languagePropertiesInverted[language]
      var names = []
      var voices = []
      if (code) {
        voices = Voice.getVoicesWithLangSubstring(code)
        voices.forEach(function (v) {
          names.push(v.name)
        })
        return names
      }
      return []
    },
    getVoices () {
      let filteredvoices = []
      if (hasSpeechSynthesis) {
        filteredvoices = speechSynthesis.getVoices().filter(function (v) {
          return true
        })
      }
      // iOS returns more than they let you select.
      if (bIsiOS) {
        let newVoices = []
        let last = filteredvoices.length - 1
        for (let i = last; i >= 0; --i) {
          for (let j = 0; j < Voice.iOSVoiceNames.length; ++j) {
            if (filteredvoices[i].name === Voice.iOSVoiceNames[j]) {
              newVoices.push(filteredvoices[i])
            }
          }
        }
        filteredvoices = newVoices
      }
      return filteredvoices
    },
    getVoicesWithLangSubstring (langSubstr) {
      var filteredvoices = this.getVoices()
      if (hasSpeechSynthesis) {
        filteredvoices = filteredvoices.filter(function (v) {
          // If we aren't getting voices by their name, lets filter out the horrible voices
          if (v.name in Voice.voiceProperties && Voice.voiceProperties[v.name].priority < Voice.minimumPriority) {
            return false
          }
          return v.lang.replace('_', '-').substring(0, langSubstr.length) === langSubstr
        })
      }
      // So does Android...all versions?

      function sortCompare (a, b) {
        let aPriority = 0
        let bPriority = 0
        if (Voice.voiceProperties[a.name]) {
          aPriority = Voice.voiceProperties[a.name].priority
        }
        if (Voice.voiceProperties[b.name]) {
          bPriority = Voice.voiceProperties[b.name].priority
        }
        if (a.name.includes('Enhanced')) {
          aPriority++
        }
        if (b.name.includes('Enhanced')) {
          bPriority++
        }
        return bPriority - aPriority
      }
      return filteredvoices.sort(sortCompare)
    },

    getLanguageForTTSVoice (ttsVoice) {
      if (ttsVoice && ttsVoice.lang && ttsVoice.lang.length >= 2) {
        return Voice.languageProperties[ttsVoice.lang.substring(0, 2)]
      }
      return Voice.languageProperties[Voice.defaultlocale.substring(0, 2)]
    },
    getTTSVoice (voiceObj) {
      let namedVoice = Voice._getVoiceWithName(voiceObj.name)
      if (namedVoice && namedVoice.lang && voiceObj.locale && voiceObj.locale.substring(0, 2) === namedVoice.lang.substring(0, 2)) {
        return namedVoice
      }
      var index = voiceObj.index
      if (index === -1) {
        // Special case code for rotating voice
        index = Voice.voiceCounter
        Voice.voiceCounter += 1
        Voice.eventEmitter.emit('randomVoice')
      }
      return Voice._getBestVoice(voiceObj.locale, voiceObj.bIsMale, index)
    },
    _getBestVoice (locale, bIsMale, index) {
      let matchingVoices = Voice._getBestVoices(locale, bIsMale)
      if (matchingVoices.length > 0) {
        if (index != null) {
          index = Math.abs(parseInt(index, 10))
          index = index % matchingVoices.length
        } else {
          index = 0
        }
        return matchingVoices[index]
      }
      // Try english voices if we didn't get any for the provided locale.
      if (locale !== 'en') {
        console.warn('No voices for locale: ' + locale + '. Are we warmed up?')
        return Voice._getBestVoice('en', bIsMale, index)
      }
      let lastResorts = []
      if (hasSpeechSynthesis) {
        lastResorts = this.getVoices()
      }
      if (lastResorts[0]) {
        return lastResorts[0]
      }
      return null
    },
    _getBestVoices (locale, bIsMale) {
      let voices = []
      let genderVoices = []
      if (locale && locale.length > 1) {
        voices = Voice.getVoicesWithLangSubstring(locale)
      }
      voices.forEach(function (v) {
        if (v.name in Voice.voiceProperties) {
          if (bIsMale === Voice.voiceProperties[v.name].male) {
            genderVoices.push(v)
          }
        } else {
          // We don't know the gender of this voice.  Let's cross our fingers.
          genderVoices.push(v)
        }
      })
      // Try with only the first two letters of the locale.
      if (genderVoices.length === 0 && locale.length > 2) {
        return this._getBestVoices(locale.substring(0, 2), bIsMale)
      }
      // Any gender will do at this point.
      if (genderVoices.length === 0) {
        voices.forEach(function (v) {
          genderVoices.push(v)
        })
      }
      return genderVoices
    },
    getLanguageCodeFromLanguage (lang) {
      if (lang in Voice.languagePropertiesInverted) {
        return Voice.languagePropertiesInverted[lang]
      }
      return 'en'
    },
    _getVoicesWithName (name) {
      if (hasSpeechSynthesis) {
        return this.getVoices().filter(function (v) {
          return v.name === name
        })
      }
      return []
    },
    _getVoiceWithName (name) {
      if (hasSpeechSynthesis) {
        let voices = this.getVoices().filter(function (v) {
          return v.name === name
        })
        if (voices.length > 0) {
          return voices[0]
        }
      }
      return null
    },
    doesSupportPitchAndRate (name) {
      let namedVoice = Voice._getVoiceWithName(name)
      if (namedVoice) {
        return namedVoice.localService === true
      }
      return false
    }
  }
})

export default Voice



// WEBPACK FOOTER //
// ./src/tts/voice.js